import { Box, Drawer, IconButton, Stack, styled, useBreakpoint } from 'ui';
import { ChevronLeft } from 'ui/icons';

import { HEADER_HEIGHT } from '../Header/Header';
import { SidebarProvider } from './SidebarContext';

export const NAV_SIDEBAR_WIDTH = 300;
export const isRouteActive = (currentPath: string, href: string) => {
  return currentPath === href || currentPath.startsWith(`${href}/`);
};

export const Sidebar = ({
  isOpen,
  onClose,
  children,
}: {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}) => {
  return (
    <SidebarProvider value={{ onClose }}>
      <Drawer
        sx={(theme) => ({
          '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            pt: theme.spacing(HEADER_HEIGHT),
            width: NAV_SIDEBAR_WIDTH,
          },
          flexShrink: 0,
          width: NAV_SIDEBAR_WIDTH,
        })}
        padding="small"
        variant="persistent"
        anchor="left"
        open={isOpen}
      >
        <Stack direction="column" height="100%">
          {children}

          <Box sx={{ justifySelf: 'center' }}>
            <div>
              <IconButton onClick={onClose} aria-label="Close">
                <ChevronLeft />
              </IconButton>
            </div>
          </Box>
        </Stack>
      </Drawer>
    </SidebarProvider>
  );
};

const Root = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })<{
  open?: boolean;
}>(({ theme }) => ({
  flexGrow: 1,
  marginLeft: `-${NAV_SIDEBAR_WIDTH}px`,
  paddingTop: theme.spacing(HEADER_HEIGHT),
  transition: theme.transitions.create('margin', {
    duration: theme.transitions.duration.leavingScreen,
    easing: theme.transitions.easing.sharp,
  }),
  variants: [
    {
      props: ({ open }) => open,
      style: {
        marginLeft: 0,
        transition: theme.transitions.create('margin', {
          duration: theme.transitions.duration.enteringScreen,
          easing: theme.transitions.easing.easeOut,
        }),
        width: `calc(100% - ${NAV_SIDEBAR_WIDTH}px)`,
      },
    },
  ],
  width: '100%',
}));

export const Main = ({ isOpen, children }: { isOpen: boolean; children: React.ReactNode }) => {
  const { isMobile } = useBreakpoint();
  const showMainMove = !isMobile ? isOpen : false; // on desktop push main content when sidebar is open; on mobile overlay sidebar on top of main

  return <Root open={showMainMove}>{children}</Root>;
};
